import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SignalingTypeEnum } from 'src/enumerators';
import { environment } from 'src/environments/environment';
import { HorizontalSignalingRetroreflection, HorizontalSignalingRetroreflectionMeasurement, TrafficSignRetroreflection } from 'src/models';
import { RestApiService } from './rest-api.service';

@Injectable({
  providedIn: 'root',
})
export class RetroreflectionService extends RestApiService {
  private endpointVar = environment.endpoint();
  private _urlCreateVerticalRetro = '/traffic-sign-retroreflections';
  private _urlCreateHorizontalRetro = '/horizontal-signaling-retroreflections';
  private _urlIndexOfTrafficRetros = '/traffic-sign-retroreflections?trafficSignId=:id';
  private _urlIndexOfHorizontalRetros = '/horizontal-signaling-retroreflections?horizontalSignalingId=:id';
  private _urlTrafficRetroWithId = '/traffic-sign-retroreflections/:id';
  private _urlHorizontalRetroWithId = '/horizontal-signaling-retroreflections/:id';
  private _urlUpdateVerticalMinAndMaxReference = '/traffic-signs/update-retroreflection?trafficSignId=:id';
  private _urlUpdateHorizontalMinAndMaxReference = '/horizontal-signalings/update-retroreflection?horizontalSignalingId=:id';
  private _urlGetRetroMeasurements = '/horizontal-signaling-retroreflection-measurements';


  constructor(public http: HttpClient) {
    super(http);
  }

  // POST  de retro de
  submitVerticalRetro(retro: TrafficSignRetroreflection) {
    return this.post(this._urlCreateVerticalRetro, new TrafficSignRetroreflection(retro), TrafficSignRetroreflection);
  }

  // GET Retorna retros da sinalização vertical
  getVerticalRetroBySignId(trafficSignId: string) {
    return this.get(this._urlIndexOfTrafficRetros.replace(':id', trafficSignId), TrafficSignRetroreflection);
  }

  // PUT update na retro de vertical
  editVerticalRetro(retro: TrafficSignRetroreflection) {
    return this.put(this._urlTrafficRetroWithId.replace(':id', retro.id), new TrafficSignRetroreflection(retro), TrafficSignRetroreflection);
  }

  // DELETE remove retro
  deleteVerticalRetro(retroId: string) {
    return this.del(this._urlTrafficRetroWithId.replace(':id', retroId), TrafficSignRetroreflection);
  }

  // POST  de retro de
  submitHorizontalRetro(retro: HorizontalSignalingRetroreflection) {
    return this.post(this._urlCreateHorizontalRetro, new HorizontalSignalingRetroreflection(retro), HorizontalSignalingRetroreflection);
  }

  // GET Retorna retros da sinalização horizontal
  getHorizontalRetroBySignId(horizontalSignalingId: string) {
    return this.get(
      this._urlIndexOfHorizontalRetros.replace(':id', horizontalSignalingId),
      HorizontalSignalingRetroreflection,
    );
  }

  // PUT update na retro de horziontal
  editHorizontalRetro(retro: HorizontalSignalingRetroreflection) {
    return this.put(this._urlHorizontalRetroWithId.replace(':id', retro.id), retro, HorizontalSignalingRetroreflection);
  }

  // DELETE remove retro
  deleteHorizontalRetro(retroId: string) {
    return this.del(this._urlHorizontalRetroWithId.replace(':id', retroId), HorizontalSignalingRetroreflection);
  }

  // PUT atualiza valores min and max da sinalização
  updateMinAndMaxValue(
    signalingType: SignalingTypeEnum,
    body: { maximumRetroreflectionValue, minimumRetroreflectionValue },
    signalingId,
  ) {
    const url =
      signalingType == SignalingTypeEnum.Vertical
        ? this._urlUpdateVerticalMinAndMaxReference.replace(':id', signalingId)
        : this._urlUpdateHorizontalMinAndMaxReference.replace(':id', signalingId);

    return this.http.patch(this.endpointVar + url, body);
  }

  // GET das localizações das retros nos estradas
  getHorizontalRetroMeasurements(belowMinimum) {
    let url = this._urlGetRetroMeasurements;

    if (belowMinimum) {
      url += '?valueBelowMinimum=true';
    }

    return this.get(url, HorizontalSignalingRetroreflectionMeasurement);
  }

  // GET das vertical qm tem retros a baixo do minimo
  getTrafficSignRetro(belowMinimum) {
    let url = this._urlCreateVerticalRetro;

    if (belowMinimum) {
      url += '?valueBelowMinimum=true';
    }

    return this.get(url, TrafficSignRetroreflection);
  }


}
